var modules_037eb246 = {"container":"_1gzd8qd"};
import "../../../assets/VDLu-MUu.css";

export { modules_037eb246 as default };
//# sourceMappingURL=CountDown.module.less.js.map
